import Box from "@mui/material/Box";
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid-pro";
import React from "react";
import {GridToolbarContainer, GridToolbarQuickFilter} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteConfirmationDialog from "../Dialogs/DeleteConfirmationDialog";

const CustomToolbar = ({ chosenRows, handleDeleteItems }) => {
    return (
        <GridToolbarContainer>
            <Box sx={{ display: "flex", gap: 1 }}>
                {!chosenRows?.length > 0 && (
                    <>
                        <GridToolbarFilterButton />
                        <GridToolbarColumnsButton />
                        <GridToolbarDensitySelector />
                        <GridToolbarExport />
                    </>
                )}

                {chosenRows && chosenRows?.length > 0 && (
                    <DeleteConfirmationDialog
                        header="Delete Confirmation"
                        title="Are you sure you want to delete these templates?"
                        description="This will remove them as an option when creating new quotes."
                        response={() => handleDeleteItems()}
                    >
                        {(showDialog) => (
                            <Tooltip
                                title='Delete'
                                arrow
                                sx={{ py: 0 }}
                            >
                                <IconButton
                                    color='error'
                                    onClick={showDialog}
                                >
                                    <DeleteIcon fontSize={"small"} />
                                </IconButton>
                            </Tooltip>
                        )}
                    </DeleteConfirmationDialog>
                )}
            </Box>

            <Box sx={{ marginLeft: "auto" }}>
                <GridToolbarQuickFilter />
            </Box>
        </GridToolbarContainer>
    );
};
const TemplatesDataGrid = ({
                               columns,
                               allRows, 
                               rowModesModel, 
                               setRowModesModel, 
                               chosenRows,
                               setChosenRows,
                               handleRowModesModelChange, 
                               loading,
                               handleDeleteItems
    }) => {
    return (
        <Box
            sx={{
                "& .new-param-theme--header": {
                    color: "white",
                },
                height: 500,
            }}
        >
            <DataGridPro
                columns={columns}
                rows={allRows}
                rowModesModel={rowModesModel}
                onRowModesModelChange={handleRowModesModelChange}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    setChosenRows(newRowSelectionModel);
                }}
                slots={{
                    toolbar: CustomToolbar,
                }}
                checkboxSelection
                loading={!!loading}
                initialState={{
                    density: 'compact',
                }}
                slotProps={{
                    toolbar: {
                        setRowModesModel,
                        handleDeleteItems,
                        chosenRows,
                        showQuickFilter: true,
                    },
                    loadingOverlay: {
                        variant: "skeleton",
                        noRowsVariant: "skeleton",
                    },
                }}
            />
        </Box>
    );
}

export default TemplatesDataGrid;